import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { makeTitlePatterns } from 'platform/shared/health-apps/patterns/titles';

export const DEFAULT_TITLE_OPTS = {
  dependents: { arrayBuilder: true, nameKey: 'fullName' },
};

export const { titleWithNameUI } = makeTitlePatterns({ nameFormat: 'full' });

/**
 * Creates a subtitle UI for subsection headings.
 *
 * Uses h2 semantic level but styled as h3 for visual hierarchy.
 * Useful for creating subsections within a form page.
 *
 * @param {string} title - The subtitle text to display
 * @returns {Object} UI schema object for titleUI with subtitle styling
 *
 * @example
 * // Add a subsection title
 * uiSchema: {
 *   ...subtitleUI('Additional information'),
 *   fieldName: textUI('Field label')
 * }
 */
export const subtitleUI = title =>
  titleUI({
    title,
    headerLevel: 2,
    headerStyleLevel: 3,
  });
